(ns renolit-roofing-service.service.project
  (:require
   [dev.gethop.session.re-frame.cognito.token :as cognito.token]
   [medley.core :as medley]
   [re-frame.core :as rf]
   [renolit-roofing-service.util :as util]))

(rf/reg-sub
 ::project
 (fn [db]
   (get db :project)))

(rf/reg-event-db
 ::clear-project
 (fn [db]
   (dissoc db :project)))

(rf/reg-event-db
 ::set-project
 (fn [db [_ project]]
   (assoc db :project project)))

(rf/reg-event-fx
 ::load-project-success
 (fn [_ [_ on-success-evt {:keys [project]}]]
   {:fx (cond-> [[:dispatch [::set-project project]]]
          on-success-evt
          (conj [:dispatch (conj on-success-evt project)]))}))

(defn- get-project-by-id-event-fx
  [{:keys [session]}
   [_ project-id {:keys [on-success-evt on-failure-evt filters related-entities extra-params]}]]
  (when session
    (let [params (cond-> {}
                   (seq filters)
                   (assoc :filters filters)

                   (seq related-entities)
                   (assoc :related-entities related-entities)

                   (seq extra-params)
                   (medley/deep-merge extra-params))]
      {:http-xhrio
       {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
        :method :get
        :uri (str "/api/projects/" project-id)
        :params params
        :response-format (util/ajax-transit-response-format)
        :on-success [::load-project-success on-success-evt]
        :on-failure [::util/generic-error-with-callback on-failure-evt {}]}})))

(rf/reg-event-fx
 ::get-project-by-id
 [(rf/inject-cofx ::cognito.token/session)]
 get-project-by-id-event-fx)

(rf/reg-sub
 ::projects-stats
 (fn [db]
   (get db :projects-stats)))

(rf/reg-event-db
 ::clear-projects-stats
 (fn [db]
   (dissoc db :projects-stats)))

(rf/reg-event-db
 ::set-projects-stats
 (fn [db [_ stats]]
   (assoc db :projects-stats stats)))

(rf/reg-event-fx
 ::load-projects-stats-success
 (fn [_ [_ on-success-evt {:keys [stats]}]]
   {:fx (cond-> [[:dispatch [::set-projects-stats stats]]]
          on-success-evt
          (conj [:dispatch (conj on-success-evt stats)]))}))

(defn- get-projects-stats-event-fx
  [{:keys [session]}
   [_ {:keys [on-success-evt on-failure-evt]}]]
  (when session
    {:http-xhrio
     {:headers {"Authorization" (str "Bearer " (get-in session [:id-token :jwt]))}
      :method :get
      :uri "/api/projects-stats"
      :response-format (util/ajax-transit-response-format)
      :on-success [::load-projects-stats-success on-success-evt]
      :on-failure [::util/generic-error-with-callback on-failure-evt {}]}}))

(rf/reg-event-fx
 ::get-projects-stats
 [(rf/inject-cofx ::cognito.token/session)]
 get-projects-stats-event-fx)

(rf/reg-sub
 ::default-map-viewport
 (fn [db]
   (:default-map-viewport db)))

;; -----------------------------------------------------------------------------
;; Saving placeholder
;; -----------------------------------------------------------------------------

(rf/reg-event-fx
 ::zones-saved
 (fn [{:keys [db]} _]
   ;; prepare pure data here if needed
   (let [_data (vals (:zones db))]
     {})))
